var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgW40PurchaseSkeuomorphic = function SvgW40PurchaseSkeuomorphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w-40-purchase-skeuomorphic_svg__a)",
    filter: "url(#w-40-purchase-skeuomorphic_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w-40-purchase-skeuomorphic_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFA",
    d: "M0 11a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v17.333a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D2D2D2",
    strokeDasharray: "1 4",
    strokeLinecap: "round",
    d: "M1.5 28.5h37M1.5 10.5h37M1.5 19.5h37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.667 28.556q3.472-4.419 3.472-7.071c0-2.652-.695-2.652-1.389-2.652s-1.411.96-1.389 2.652c.024 1.81 1.152 4.31 1.736 5.303 1.042 1.768 1.736 2.21 2.43.884l1.39-2.652q.345 3.536 2.083 3.536c.368 0 1.833-1.768 2.083-1.768q.54 0 2.084 1.768"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#w-40-purchase-skeuomorphic_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B5CF6",
    d: "M-7.404 14.49a6.5 6.5 0 0 1 0-9.192L.298-2.404A6.5 6.5 0 1 1 9.49 6.788L1.79 14.492a6.5 6.5 0 0 1-9.193 0"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#E8E8E8",
    d: "M8 3.5h24a7.5 7.5 0 0 1 7.5 7.5v17.333a7.5 7.5 0 0 1-7.5 7.5H8a7.5 7.5 0 0 1-7.5-7.5V11A7.5 7.5 0 0 1 8 3.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w-40-purchase-skeuomorphic_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33.333,
    y: 3,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w-40-purchase-skeuomorphic_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 11a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v17.333a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w-40-purchase-skeuomorphic_svg__b",
    width: 42,
    height: 35.333,
    x: -1,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2_897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w-40-purchase-skeuomorphic_svg__d",
    width: 22.702,
    height: 22.702,
    x: -10.308,
    y: -4.308,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.85098 0 0 0 0 0.976471 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2_897",
    result: "shape"
  })))));
};
export default SvgW40PurchaseSkeuomorphic;